import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import eventbg from "../../assets/img/event-bannar.png";
import bttnicon from "../../assets/img/creat-post.svg";
import profile from "../../assets/img/prfo-img.svg";
import checkb from "../../assets/img/event/attending.svg"
import profileimg from "../../assets/img/profile/profile-img.svg"
import { API } from '../../services/api';
import AttendPopUp from './AttendPopUp';
const ViewEventTopBar = ({ banner, details, attendStatus, fetchEventDetails }) => {
  const user = JSON.parse(localStorage.getItem('userData'));
  const [isAttend, setIsAttend] = useState(false);
  const handleAttendClose = () => setIsAttend(false);
  const [attendMode, setAttendMode] = useState("");
  const isButtonDisabled = details?.userId?._id === user?._id;


  return (
    <div>
      <div className="hd-breadcums">
        <h3 className="main-heading"> Events</h3>
      </div>
      <div className="community-details mb-4">
        <div className='community_cover-img mb-5'>
          <img src={banner ? API.uploadFilePath + banner : profileimg} alt="test" className="cover-bg-community" />
          <div class="overlay"></div>
        </div>

        <div className="profile-div d-flex community-actions mb-5" style={
          details?.userId?._id && user?._id
            ? (isButtonDisabled ? { opacity: 0, pointerEvents: 'none' } : {})
            : { visibility: 'hidden' } // optional: hide while loading
        }>
          <div class="community-icon-thumb right-bttn" >

            {
              attendStatus === 0 ? <button className="btn creat-bttn create-dh" onClick={() => { setIsAttend(true);setAttendMode("attend"); }} >
                <img src={bttnicon} className="creat-icon" alt="Create Icon" /><span>Attend</span>
              </button> :
                <button className="btn creat-bttn create-dh" onClick={() => { setIsAttend(true); setAttendMode("cancel"); }} >
                  <img src={checkb} className="creat-icon" alt="Create Icon" /><span>Attending</span>
                </button>}
          </div>


        </div>
      </div>
      {isAttend && <AttendPopUp isAttend={isAttend} handleClose={handleAttendClose} eventId={details._id} listEvent={fetchEventDetails} mode={attendMode}/>}
    </div>

  );


};
export default ViewEventTopBar;